export default __webpack_public_path__ + "static/media/cleuma-gonzalez.20602171.webp";